export interface Resource extends Record<string, any> {
  id: string;
  organizationId?: string;
  name: string;
  descriptiveId: string;
  description: string;
}
